import { Component } from '@angular/core';

import { FormlyFieldConfig } from '@ngx-formly/core';

import { PageFieldType } from 'dspx-core';

import { CUSTOM_FIELD_TYPE } from '../../constants/app-data.constants';

@Component({
  selector: 'dspx-card-set-page-with-collapsible-sections',
  templateUrl: './card-set-page-with-collapsible-sections.component.html'
})
export class CardSetPageWithCollapsibleSectionsFieldType extends PageFieldType {
  sectionBodyFields: FormlyFieldConfig[] = [];
  questionCountInSection: number = 0;

  ngOnInit() {
    if (this.field.key !== 'form') {
      this.field.props.totalQuestionCount = 0;
      this.field.props.answeredQuestionCount = 0;
      this.field.fieldGroup.forEach(fieldGroup => {
        this.setCount(fieldGroup);
        fieldGroup.formControl.valueChanges.subscribe(value => {
          this.trackFieldChanges(fieldGroup);
        });
      })
    }
  }

  trackFieldChanges(field: FormlyFieldConfig): void {
    this.field.props.totalQuestionCount = 0;
    this.field.props.answeredQuestionCount = 0;
    if (field.model) {
      this.field.fieldGroup.forEach(fieldGroup => {
        this.setCount(fieldGroup);
      });
    }
  }

  setCount(field: FormlyFieldConfig) {
    this.field.props.totalQuestionCount += this.getFieldsCountForSection(field);
    this.field.props.answeredQuestionCount += this.getAnsweredCount(field);
  }

  getFieldsCountForSection(field: FormlyFieldConfig): number {
    if (field.type === CUSTOM_FIELD_TYPE.cardSectionCollapsible) {
      return this.getQuestionCountForSection(field);
    }
    else if (field.type === CUSTOM_FIELD_TYPE.cardSectionRepeatingCollapsible) {
      return this.getQuestionCountForRepeatingSection(field);
    }
  }

  getAnsweredCount(field: FormlyFieldConfig): number {
    if (field.type === CUSTOM_FIELD_TYPE.cardSectionCollapsible) {
      return this.getAnswerCountForSection(field) ?? 0;
    }
    else if (field.type === CUSTOM_FIELD_TYPE.cardSectionRepeatingCollapsible) {
      return this.getAnswerCountForRepeatingSection(field);
    }
  }

  getAnswerCountForSection(field: FormlyFieldConfig): number {
    if (field.model) {
      return Object.keys(field.model).filter(
        key => !this.isHeaderQuestion(key) && field.model[key] !== null && field.model[key] !== ''
      ).length;
    }
  }

  getAnswerCountForRepeatingSection(field: FormlyFieldConfig): number {
    if (field.model) {
      return field.model.reduce((acc, obj) => {
        Object.keys(obj).forEach(key => {
          if (!this.isHeaderQuestion(key) && obj[key] !== null && obj[key] !== '') {
            acc++;
          }
        });
        return acc;
      }, 0);
    }
  }

  getQuestionCountForSection(field: FormlyFieldConfig): number {
    this.sectionBodyFields = field.fieldGroup.filter(f => !this.isHeaderQuestion(f.key.toString()));

    return this.sectionBodyFields.length;
  }

  getQuestionCountForRepeatingSection(field: FormlyFieldConfig): number {
    this.sectionBodyFields = field.fieldGroup[0]?.fieldGroup?.filter(f => !this.isHeaderQuestion(f.key.toString()));
    if (field.model?.length > 0) {
      return this.sectionBodyFields.length * field.model.length;
    }
    return this.sectionBodyFields?.length;
  }

  isExistsQuestion = (questionCode: string): boolean => questionCode.endsWith('-exists');
  isNotAssessedQuestion = (questionCode: string): boolean => questionCode.endsWith('-notassessed');
  isEditingQuestion = (questionCode: string): boolean => questionCode === 'isEditing';
  isHeaderQuestion = (questionCode: string): boolean => this.isExistsQuestion(questionCode) || this.isNotAssessedQuestion(questionCode) || this.isEditingQuestion(questionCode);
}
